import { gql } from '@apollo/client';

export const DOCUMENT_TYPE_PROPERTY_UPDATED = gql`
  subscription documentTypePropertyUpdated {
    documentTypePropertyUpdated {
      documentTypeId
      propertyId
    }
  }
`;

export const DOCUMENT_TYPE_PROPERTY_X_STATE_UPDATED = gql`
  subscription documentTypePropertyXStateUpdated {
    documentTypePropertyXStateUpdated {
      documentTypeId
      propertyId
    }
  }
`;
